import { render, staticRenderFns } from "./EditRemitent.vue?vue&type=template&id=7fc64033&"
import script from "./EditRemitent.vue?vue&type=script&lang=js&"
export * from "./EditRemitent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports